// ENHANCED SELECT UTILITITTIES

import { Option } from '../Select';

// default items title sorting method
export const defaultSort = (a: Option, b: Option) => {
  const lowerCaseA = a?.label?.toLowerCase();
  const lowerCaseB = b?.label?.toLowerCase();

  if (lowerCaseA === lowerCaseB) return 0;

  return lowerCaseA < lowerCaseB ? -1 : 1;
};

export const getMinSelections = (
  min: number,
  max: number,
  maxDataLength: number,
  isAllOrOne: boolean,
) => {
  if (min <= maxDataLength && min <= max) return min;

  if (isAllOrOne) return 1;

  return 0;
};

export const getMaxSelections = (
  min: number,
  max: number,
  maxDataLength: number,
) => {
  if (max >= min && max <= maxDataLength) return max;

  return maxDataLength;
};

export const getIsControllerDisabled = (
  options: Option[] | null,
  searchValue: string,
) => {
  return !options || (options && !options.length && !searchValue);
};
